var Request = require("../../helper/request");
var Event = require('./feed/event');

function Feed(app, companyId){
	var self = this;
	self.app = app;
	self.request = new Request(app);
	self.companyId = companyId;

	self.routes = {
		index: {
			url: "/company/"+self.companyId+"/search/feed?q=:query",
			method: "GET"
		}
	};
}

Feed.prototype.index = function(query){
	var self = this;
	var uri = self.routes.index.url.replace(":query", query);
	return self.request.get(uri);
};

Feed.prototype.event = function(){
	var self = this;
	return new Event(self.app, self.companyId);
};

module.exports = Feed;